import React, { useState } from 'react';
import { Button, Input } from '../shared';
import type { LoginInput } from '../../types';
import styles from './AuthForms.module.css';

interface LoginFormProps {
  onSubmit: (input: LoginInput) => Promise<void>;
  onSwitchToRegister: () => void;
  error: string | null;
  isLoading: boolean;
}

export const LoginForm: React.FC<LoginFormProps> = ({
  onSubmit,
  onSwitchToRegister,
  error,
  isLoading,
}) => {
  const [formData, setFormData] = useState<LoginInput>({
    email: '',
    password: '',
  });

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    await onSubmit(formData);
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Welcome Back</h1>
      <p className={styles.subtitle}>Sign in to your PTai account</p>

      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          type="email"
          label="Email"
          placeholder="trainer@example.com"
          value={formData.email}
          onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
          required
          disabled={isLoading}
        />

        <Input
          type="password"
          label="Password"
          placeholder="••••••••"
          value={formData.password}
          onChange={(e) => setFormData(prev => ({ ...prev, password: e.target.value }))}
          required
          disabled={isLoading}
        />

        {error && <div className={styles.error}>{error}</div>}

        <Button
          type="submit"
          fullWidth
          isLoading={isLoading}
          disabled={!formData.email || !formData.password}
        >
          Sign In
        </Button>
      </form>

      <p className={styles.switch}>
        Don&apos;t have an account?{' '}
        <button
          type="button"
          className={styles.switchLink}
          onClick={onSwitchToRegister}
          disabled={isLoading}
        >
          Sign up
        </button>
      </p>
    </div>
  );
};
